import { render, staticRenderFns } from "./law-content.vue?vue&type=template&id=7e64a120&scoped=true&"
import script from "./law-content.vue?vue&type=script&lang=js&"
export * from "./law-content.vue?vue&type=script&lang=js&"
import style0 from "./law-content.vue?vue&type=style&index=0&id=7e64a120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e64a120",
  null
  
)

export default component.exports